module.exports = __webpack_public_path__ + "img/product2.02284aca.png";